import React, { useContext } from 'react';
import ArrowLeft from '../../../../../../Assets/Arrow left.svg';
import Cross from '../../../../../../Assets/Modals/closeIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, setEditSection, setModal, setVideo, setVideoPostMenu } from '../../../../../../Features/lensSlice';
import Option from './Option';
import AudioEdit from './AudioEdit';
import TextEdit from './TextEdit';
import TrimEdit from './TrimEdit';
import VoiceoverEdit from './VoiceoverEdit';
import { VideoContext } from '../../../../../../Context/VideoContext';

import AudioIcon from '../../../../../../Assets/Lens/Audio.svg';
import AudioGreenIcon from '../../../../../../Assets/Lens/AudioGreen.svg';
// import TextIcon from '../../../../../../Assets/Lens/Text.svg';
// import TextGreenIcon from '../../../../../../Assets/Lens/TextGreen.svg';
import TrimIcon from '../../../../../../Assets/Lens/trim.svg';
import TrimGreenIcon from '../../../../../../Assets/Lens/TrimGreen.svg';
import VoiceoverIcon from '../../../../../../Assets/Lens/microphone.svg';
import VoiceoverGreenIcon from '../../../../../../Assets/Lens/MicrophoneGreen.svg';

function EditSection() {
    const dispatch = useDispatch();

    const editSection = useSelector((state) => state.lens.video.editSection);

    const { selectedAudio, setSelectedAudio, setVideoFile } = useContext(VideoContext);

    const changeEditSection = (selection) => {
        dispatch(setEditSection(selection));
    }

    const handlePreviousClick = () => {
        setSelectedAudio({});
        setVideoFile({});
        dispatch(setModal('video-post'));
        dispatch(setVideo(null));
        dispatch(setEditSection(null));
        setSelectedAudio({});
    }

    const handleCloseModal = () => {
        dispatch(closeModal());
        dispatch(setVideo(null));
        dispatch(setEditSection(null));
    }

    const handleNextButton = () => {
        dispatch(setVideoPostMenu('form'));
    }

    return (
        <div className="w-2/5 relative flex flex-col h-full">
            <div className="flex items-center justify-between px-4 pt-4">
                <div className="flex items-center gap-2">
                    <button onClick={handlePreviousClick} className="size-11 flex items-center justify-center">
                        <img src={ArrowLeft} alt="" />
                    </button>

                    <h1 className='font-semibold text-2xl text-[#121212]'>Video Post</h1>
                </div>

                <button onClick={handleCloseModal} className="size-11 flex items-center justify-center">
                    <img src={Cross} alt="" />
                </button>
            </div>

            <div className="mt-4 mx-4 px-5 py-[10px] grid grid-cols-3 gap-x-6 rounded-xl bg-[#F5F5F5]">
                <Option 
                    icon={editSection === 'audio' ? AudioGreenIcon : AudioIcon} 
                    image={Object.keys(selectedAudio).length > 0 && selectedAudio?.thumbnail['150x150']} 
                    title={'Audio'} 
                    onClick={() => changeEditSection('audio')} 
                />

                {/* <Option 
                    icon={editSection === 'text' ? TextGreenIcon : TextIcon} 
                    title={'Text'} 
                    onClick={() => changeEditSection('text')} 
                /> */}

                <Option 
                    icon={editSection === 'trim' ? TrimGreenIcon : TrimIcon} 
                    title={'Trim'} 
                    onClick={() => changeEditSection('trim')} 
                />
                
                <Option 
                    icon={editSection === 'voiceover' ? VoiceoverGreenIcon : VoiceoverIcon} 
                    title={'Voiceover'} 
                    onClick={() => changeEditSection('voiceover')} 
                />
            </div>

            {editSection === 'audio' && <AudioEdit />}
            {editSection === 'text' && <TextEdit />}
            {editSection === 'trim' && <TrimEdit />}
            {editSection === 'voiceover' && <VoiceoverEdit />}

            {!editSection && <div className="absolute bottom-0 left-0 w-full px-4 py-3 bg-[#FFFFFF] border-t border-[#EAEAEA]">
                <button onClick={handleNextButton} className='w-full px-4 py-[6px] rounded-md bg-primaryColor hover:bg-primaryAccent font-semibold text-[14px] leading-[26px] text-buttonText'>Next</button>
            </div>}
        </div>
    );
}

export default EditSection;
